import { ReturnsAndClaimsPermissions } from "@redotech/account-common/permissions";
import * as z from "zod";
import { canRejectReturn } from "../../returns/return-action-eligibility";
import { defineReturnAction } from "../types";

/**
 * No customerRecoveryAmount: the single-return modal caps it per return
 * (totals.returnCollectionHoldAmount), so bulk reject always sends 0.
 */
const BulkRejectPayloadSchema_ = z.object({
  sendNotification: z.boolean(),
  customerNotes: z.string().optional(),
  handOffToMerchant: z.boolean(),
});
export interface RejectPayload extends z.infer<
  typeof BulkRejectPayloadSchema_
> {}

export const rejectReturnAction = defineReturnAction<RejectPayload>({
  label: "Reject",
  mutation: "rejectReturns",
  permissions: [ReturnsAndClaimsPermissions.PROCESS_RETURN],
  irreversible: true,
  isEligible: ({ return_, user }) => canRejectReturn({ return_, user }),
  payloadSchema: BulkRejectPayloadSchema_,
  examplePayload: {
    sendNotification: true,
    customerNotes: "Items arrived outside the return window",
    handOffToMerchant: false,
  },
});
